module.exports = __webpack_public_path__ + "static/media/img21.4b862244.jpg";